import { Nullable } from '@recruitee/common';
import { EditorJSONState } from '@recruitee/prosemirror-types';
import type {
  Requisition,
  RequisitionOpening,
  RequisitionsListParam,
  RequisitionsParams,
  RequisitionStatus,
} from '@recruitee/requisitions-types';

export type RequisitionUpdateData = Partial<{
  id: number;
  approvalFlowId: number;
  title: string | null;
  departmentId: null | number;
  category: string | null;
  education: string | null;
  employmentType: string | null;
  experience: string | null;
  hiringBudget: number | null;
  hiringBudgetCurrency: string | null;
  hiringManagerId: number | null;
  maxHoursPerWeek: string | null;
  minHoursPerWeek: string | null;
  openings: OpeningUpdateBody[];
  recruiterId: number | null;
  salary: {
    currency: string | null;
    max: string | null;
    min: string | null;
    period: string | null;
  };
}>;

export type RequisitionsGroupEntity = {
  name?: string;
  count: number;
  requisitionIds: number[];
  requisitions?: Requisition[];
};

export type RequisitionsGroup = {
  name?: string;
  count: number;
  requisitions: Requisition[];
};

export type RequisitionApprovalRequestUpdateData = {
  id: number;
  status: RequisitionStatus;
  approvalRequest?: ApprovalRequestPayload;
};

export type RequisitionCreateData = {
  title: string;
  approvalFlowId?: number;
  departmentId?: number | null;
};

export type RequisitionUpdatePayload = { requisition: RequisitionUpdateData };
export type RequisitionApprovalRequestPayload = {
  requisition: RequisitionApprovalRequestUpdateData;
};
export type RequisitionCreatePayload = {
  requisition: RequisitionCreateData;
};
export type OpeningUpdateBody = Nullable<Partial<RequisitionOpening>>;

export type RequisitionsFetchCollectionResponse = {
  requisitions: Requisition[];
};

export type RequisitionsGroupedFetchCollectionResponse = {
  groups: RequisitionsGroup[];
};

export type RequisitionResponse = {
  requisition: Requisition;
};

export type ApprovalRequestPayload = {
  bodyJson: EditorJSONState | object | null;
  attachments: number[];
};

export enum DuplicateViewContext {
  Dialog = 'dialog',
  Page = 'page',
}

export enum UpdateContext {
  Default = 'default',
  ApprovalRequest = 'approval_request',
  ChangeTab = 'change_tab',
}

export type RequisitionsNonGroupedParams = Omit<RequisitionsParams, RequisitionsListParam.GroupBy>;
export type RequisitionsGroupedParams = RequisitionsParams;
